<template>
	<div class="department_users">
		<FunctionTitle :title="mainTitle" />
		<CommonFlame :title="`${department_name}に所属する社員一覧`">
			<template v-if="!$vuetify.breakpoint.xs && authority_flag" v-slot:app-bar-btn>
				<DepartmentUserFormDialog
					text
					:department_id="id"
					:company_users="users"
					@reload="fetchDepartmentUsers(pagination.current)"
				/>
			</template>
			<v-row v-if="$vuetify.breakpoint.xs && authority_flag" no-gutters justify="end">
				<DepartmentUserFormDialog
					:department_id="id"
					:company_users="users"
					@reload="fetchDepartmentUsers(pagination.current)"
				/>
			</v-row>
			<v-container>
				<div class="table-container mt-4">
					<v-data-table
						locale="ja-JP"
						:headers="headers"
						:items="department_users"
						:mobile-breakpoint="240"
						hide-default-footer
						disable-filtering
						disable-pagination
						disable-sort
						no-data-text="データがありません。"
					>
						<template v-slot:item="{ item }">
							<tr class="no-click">
								<td>{{ item.user_info.employee_number }}</td>
								<td>{{ item.full_name }}</td>
								<td>{{ item.position }}</td>
								<td>
									<template v-if="authority_flag">
										<TemplateDeleteDialog onlyIcon ref="“deleteDialog”">
											<template v-slot:title>本当に部門から外しますか</template>
											<template v-slot:text>
                        部門から外すと、社員の所属部門がなくなります。
                        <br/>
                        本当に部門から外しますか？
                      </template>
											<template v-slot:button>
												<v-row no-gutters justify="center">
													<v-btn
														class="ma-1"
														@click="deleteDepartmentUser(item.id)"
														dense
														dark
														color="red"
													>
														部門から外す
													</v-btn>
												</v-row>
											</template>
										</TemplateDeleteDialog>
									</template>
								</td>
							</tr>
						</template>
					</v-data-table>
				</div>
				<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
			</v-container>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import CommonFlame from "../shared/CommonFlame.vue"
import DepartmentUserFormDialog from "./components/DepartmentUserFormDialog.vue"
import PaginationModule from "../../modules/PaginationModule.vue"
import TemplateDeleteDialog from "../shared/TemplateDeleteDialog.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"

export default {
	components: {
		CommonFlame,
		FunctionTitle,
		DepartmentUserFormDialog,
		PaginationModule,
		TemplateDeleteDialog,
	},
	data() {
		return {
			id: this.$route.params["id"],
			mainTitle: "ユーザー部門設定",
			headers: [
				{ text: "社員番号", value: "user_info.employee_number", width: "150px" },
				{ text: "社員名", value: "full_name", width: "250px" },
				{ text: "役職", value: "position", width: "150px" },
				{ text: "", value: "", width: "50px" },
			],
			department_users: [],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			authority_flag: false,
			department_name: "",
		}
	},
	created() {
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.fetchDepartmentUsers(page)
	},

	methods: {
		fetchDepartmentUsers(page) {
			authenticate.authenticateUser()
			const headers = authenticate.setHeader()
			axios
				.get(`/erp/v1/departments/${this.id}/department_users`, { params: { page: page }, headers })
				.then((res) => {
					this.department_users = res.data.department_users
					this.pagination = res.data.pagination
					this.authority_flag = res.data.authority_flag
					this.users = res.data.users
					this.department_name = res.data.department.name
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		getPage(page) {
			this.fetchDepartmentUsers(page)
		},

		deleteDepartmentUser(id) {
			const headers = authenticate.setHeader()
			const delete_id = id
			axios
				.delete(`/erp/v1/departments/${this.id}/department_users/${delete_id}`, { headers })
				.then((res) => {
					this.$router.go({ path: this.$router.currentRoute.path })
					this.$store.commit("setFlash", {
						text: "削除しました",
						type: "notice",
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
}
</script>